module.exports = __webpack_public_path__ + "static/media/social-feed.3609045c.svg";